<template>
  <div
    class="text-page"
    :class="{
      bold,
      xsmallSize,
      smallSize,
      normalSize,
      midSize,
      largeSize,
      largeXLSize,
      largeXXLSize,
      grayLight,
      gray,
      grayDark,
      themeColor,
      orange,
      grey,
      warning,
      center: showIcon
    }"
  >
    <div v-if="showIcon" class="icon" :class="{iconBook, iconStar, iconMark, iconLack, iconTesting}"></div>
    <svg :class="{mark1, mark2}" v-if="showMark && (mark1 || mark2)">
      <circle cx="0.08rem" cy="0.31rem" r="0.08rem" fill="rgb(31, 184, 191)" v-if="mark1" />
      <circle cx="0.2rem" cy="0.32rem" r="0.12rem" fill="rgb(31, 184, 191)" v-if="mark2" />
    </svg>
    <div class="content">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Texts',
  props: {
    bold: Boolean,
    xsmallSize: Boolean,
    smallSize: Boolean,
    normalSize: Boolean,
    midSize: Boolean,
    largeSize: Boolean,
    largeXLSize: Boolean,
    largeXXLSize: Boolean,
    grayLight: Boolean,
    gray: Boolean,
    grayDark: Boolean,
    themeColor: Boolean,
    orange: Boolean,
    grey: Boolean,
    warning: Boolean,
    showIcon: Boolean,
    'icon-book': Boolean,
    'icon-star': Boolean,
    'icon-mark': Boolean,
    'icon-lack': Boolean,
    'icon-testing': Boolean,
    showMark: Boolean,
    mark1: Boolean,
    mark2: Boolean
  }
};
</script>

<style scoped lang="less">
.text-page {
  font-size: 28px;
  color: #484848;
  display: flex;
  line-height: 1.6;
  &.center {
    align-items: center;
  }

  &.bold {
    font-weight: bold;
  }
  &.xsmallSize {
    font-size: 24px;
  }
  &.smallSize {
    font-size: 26px;
  }
  &.normalSize {
    font-size: 28px;
  }
  &.midSize {
    font-size: 30px;
  }
  &.largeSize {
    font-size: 36px;
  }
  &.largeXLSize {
    font-size: 40px;
  }
  // &.large-XLSize {
  //   font-size: 48px;
  // }
  &.largeXXLSize {
    font-size: 72px;
  }
  &.grayLight {
    color: #1e1e1e;
  }
  &.gray {
    color: #484848;
  }
  &.grayDark {
    color: #121212;
  }
  &.themeColor {
    color: #1fb8bf;
  }
  &.orange {
    color: #ff6d00;
  }
  &.warning {
    color: #ff777b;
  }
  &.grey {
    color: #97969b;
  }
  .content {
    flex: 1;
  }
  .icon {
    width: 30px;
    height: 32px;
    margin-right: 18px;
  }
  .iconBook {
    background: url('./imgs/icon1.png') no-repeat center;
    background-size: contain;
  }
  .iconStar {
    background: url('./imgs/icon2.png') no-repeat center;
    background-size: contain;
  }
  .iconMark {
    background: url('./imgs/icon3.png') no-repeat center;
    background-size: contain;
  }
  .iconTesting {
    background: url('./imgs/icon4.png') no-repeat center;
    background-size: contain;
  }
  .iconLack {
    height: 30px;
    background: url('./imgs/icon_lack.png') no-repeat center;
    background-size: contain;
  }
  .mark1 {
    height: 40px;
    width: 24px;
  }
  .mark2 {
    width: 44px;
    height: 44px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Texts/index.vue